import { t } from 'i18next';
import styles from './ForgotPassword.module.scss';
import { TextInput } from '@/components/common/TextInput/TextInput';
import React, { useState } from 'react';
import { useUser } from '@/hooks';
import { validateUtils } from '@/utils/helpers/validation';
import { ERROR_CODES_FIREBASE } from '@/constants/integrations/firebase';
import { Trans } from 'react-i18next';
import {
  Button,
  EButtonHierarchy,
  EButtonSize,
} from '@/components/common/Button/Button';
import { setFullPageLoader } from '@/store/reducers';
import { useDispatch } from 'react-redux';

interface IForgotPasswordProps {
  onSuccess: (email: string) => void;
}
export const ForgotPassword: React.FC<IForgotPasswordProps> = (
  props: IForgotPasswordProps
) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const userHook = useUser();
  const handleSendResetPassword = async () => {
    setError('');
    if (email === '') {
      setError(t('validation.email.required'));
      return;
    }
    if (!validateUtils.validateEmail(email)) {
      setError(t('validation.email.invalid'));
      return;
    }
    try {
      dispatch(setFullPageLoader(true));
      await userHook.sendResetPasswordEmail(email);
      props.onSuccess(email);
      dispatch(setFullPageLoader(false));
    } catch (e: any) {
      dispatch(setFullPageLoader(false));
      if (e.code === ERROR_CODES_FIREBASE.EMAIL_NOT_FOUND) {
        setError(t('validation.email.notFound'));
      } else {
        setError(t('validation.email.invalid'));
      }
    }
  };

  return (
    <div className={styles.forgotPasswordWrapper}>
      <div className={styles.formWrapper}>
        <TextInput
          type="email"
          placeholder={t('forgotPassword.placeholders.email')}
          value={email}
          onChange={setEmail}
          error={error}
          onEnter={handleSendResetPassword}
        />
      </div>
      <Button
        fillWidth={true}
        onClick={handleSendResetPassword}
        size={EButtonSize.md}
        hierarchy={EButtonHierarchy.primary}
      >
        <Trans i18nKey="buttons.sendResetPassword" />
      </Button>
    </div>
  );
};
